module.exports = __webpack_public_path__ + "static/media/cameraPurple.7337c808.svg";